import { createApp } from 'vue'
import { router } from './router'
import App from './App.vue'
import { createPinia } from 'pinia'
import './assets/font/font-icon.css'
import './assets/style/main.scss'
import 'animate.css'
import 'nprogress/nprogress.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import myDirective from './utils/directive'
import 'default-passive-events'
// import '../src/utils/_lib-flexible.js'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)
myDirective(app) //自定义指令
app.use(router).use(pinia)
app.mount('#app')
